shadow$provide[112] = function(require,module,exports) {
var require$three = require("three");
var require$_DOT__DOT__SLASH_bootstrap = require("../bootstrap");
require$_DOT__DOT__SLASH_bootstrap.Bootstrap.registerPlugin("scene", {install:function(three) {
  three.scene = new require$three.Scene();
}, uninstall:function(three) {
  delete three.scene;
},});

};